/******/ (() => { // webpackBootstrap
/*!****************************************!*\
  !*** ./src/js/recommended-products.js ***!
  \****************************************/
/*
BG: This function uses the recommended products API by Shopify. We firstly pass over the product ID we want to display recommended on, and then for each result, request the product.card template to get the look.
*/
var recommendedProducts = function recommendedProducts() {
  //determine if the recommendProducts class section is present
  var recommended = document.querySelector('.js-recommended-products');
  var flickityPresent = false;

  //We planning on using flickity?, we check to see if the inline attribute is present.
  if (recommended.hasAttribute('data-flickity')) {
    flickityPresent = true;
  }
  //if it is....
  if (!!recommended) {
    //Get the productID from the data attribute
    var productID = parseInt(recommended.getAttribute('data-product-id'));

    //using that productID, query the recommended products API
    fetch(window.Shopify.routes.root + "recommendations/products.json?product_id=".concat(productID, "&limit=6")).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var products = _ref.products;
      // check if any products returned
      if (products.length > 0) {
        var countClass = null;
        if (products.length < 2) {
          countClass = "recommended-products--undertwo";
        } else if (products.length < 3) {
          countClass = "recommended-products--underthree";
        } else if (products.length < 4) {
          countClass = "recommended-products--underfour";
        }
        recommended.classList.add(countClass);
        var promiseList = [];

        //with the response, loop through each product.
        products.forEach(function (product, index) {
          promiseList.push(fetch(window.Shopify.routes.root + "products/".concat(product.handle, "?view=card")).then(function (response) {
            return response.text();
          }));
        });
        Promise.all(promiseList).then(function (htmls) {
          var finalHtml = '';
          htmls.forEach(function (html, index) {
            finalHtml += html;
          });
          var recommended = document.querySelector('.js-recommended-products');
          recommended.innerHTML = finalHtml;
          //if last product, and we're using flickity....
          if (recommended.hasAttribute('data-flickity-special') == true) {
            var options = JSON.parse(recommended.getAttribute('data-flickity-special'));
            new Flickity('.js-recommended-products', options);
          }
        });
      } else {
        recommended.parentNode.classList.add('hidden');
      }
    })["catch"](function (error) {
      console.error('Error:', error);
    });
  }
};
recommendedProducts();
/******/ })()
;